export default __webpack_public_path__ + "static/media/2.ed0028d0.jpeg";